
export enum TempleteType {
    templeteOne = 1,
    templeteTwo = 2,
    templeteThree = 3,
    templeteFour = 4,
    templeteFive = 5,
    templeteSix = 6,
    templeteSeven = 7,
    templeteEight = 8,
    templeteNine= 9,
    templeteTen = 10,
    templeteEleven = 11,
    templeteTwelve = 12,
    templeteThirteen = 13,
    templeteFourteen = 14,
    templeteFifteen = 15,
    templeteSixteen = 16,
    templeteSeventeen = 17,
    templeteEighteen = 18,
    templeteNineteen = 19,
    templeteTwenty = 20,
    templeteTwentyOne = 21,
}
